export default __webpack_public_path__ + "static/media/MTbasico_Posterior.42bd3257.webp";